import type { App } from "vue";
import { PiniaColada } from "@pinia/colada";
import { PiniaColadaAutoRefetch } from "@pinia/colada-plugin-auto-refetch";
import { PiniaColadaDelay } from "@pinia/colada-plugin-delay";

export function createPiniaColada(app: App) {
  app.use(PiniaColada, {
    plugins: [PiniaColadaAutoRefetch(), PiniaColadaDelay()],
  });
}
